export default "__VITE_ASSET__DGOqTYNT__"